<template>
  <div id="page_landing" class="column p0 minH100">
    <div class="cointainer_xl grid landing_grid">
      <div class="column_landing">
        <div class="component_card combo_1">
          <landing-balance
            @toggleModalCurrencies="showModalCurrencies('balance')"
            @toggleModalBlueClub="showModalBlueClub('balance')"
            @toggleModalClainBlueClub="showModalClainBlueClub('balance')"
          />
        </div>

        <div v-if="modalCurrencies">
          <modalOtherCurrencies
            @toggleModalCurrencies="showModalCurrencies()"
            :type="type"
          />
        </div>

        <div v-if="modalBlueClubInfo">
          <modalBlueClubInfo
            @toggleModalCurrencies="showModalBlueClub()"
            :type="type"
          />
        </div>

        <div v-if="modalClainBlueClubInfo">
          <modalClainBlueClubInfoVue
            @toggleModalCurrencies="showModalClainBlueClub()"
            :type="type"
          />
        </div>

        <div class="component_card combo_1">
          <todays-market
            @toggleModalCurrencies="showModalCurrencies('price')"
          />
        </div>
      </div>
      <!-- v-if="!maintenanceStatus" -->
      <div class="column_landing">
        <div class="component_card combo_1">
          <landing-buy-redeem
            @maintenanceCheck="maintenanceCheck"
          ></landing-buy-redeem>
        </div>

        <div class="component_card combo_1">
          <landing-recent-transactions></landing-recent-transactions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LandingBalance from "../../components/private/landing/LandingBalance2";
import TodaysMarket from "../../components/private/landing/TodaysMarket";
import LandingBuyRedeem from "../../components/private/landing/LandingBuyRedeem";
import LandingPortfolio from "../../components/private/landing/LandingPortfolio";
import LandingPortfolioList from "../../components/private/landing/LandingPortfolioList";
import LandingRecentTransactions from "../../components/private/landing/LandingRecentTransactions";
import ModalOtherCurrencies from "../../components/modals/modalOtherCurrencies.vue";

import modalBlueClubInfo from "../../components/modals/modalBlueClubInfo.vue";
import modalClainBlueClubInfoVue from "../../components/modals/modalClainBlueClubInfo.vue";

import { mapGetters } from "vuex";

export default {
  created() {
    this.getMaintenanceStatus();
    // this.orderAssetList(this.assetListFake);

    this.getAssetsTail();
    this.convertValues();
    this.getAccounts();

    this.getFundTails();
    console.log(this.usdtValue[0].symbol);
  },
  mounted() {},
  data: () => ({
    updateBalance: "", //remove
    balance: "0", //remove
    maintenanceStatus: "",
    state: "list",
    active: false,
    isLanding: true,
    assetList: "",
    type: "",

    cryptoEquivalence: ["BTC", "ETH", "RAS", "USDT"], //remove
    BTC: "", //remove
    ETH: "", //remove
    RAS: "", //remove
    USDT: "",
    balanceBlu: "",
    fundTails: "",
    modalCurrencies: false,
    modalBlueClubInfo: false,
    modalClainBlueClubInfo: false,
    showBalance: true,
  }),
  components: {
    LandingBalance,
    TodaysMarket,
    LandingBuyRedeem,
    LandingPortfolio,
    LandingPortfolioList,
    LandingRecentTransactions,
    ModalOtherCurrencies,
    modalBlueClubInfo,
    modalClainBlueClubInfoVue
  },
  methods: {
    async convertValues() {
      let currencies;
      for (let i in this.cryptoEquivalence) {
        let resp = await this.$store.dispatch(
          "getCurrencyByPair",
          this.cryptoEquivalence[i]
        );

        if (resp.status == 200) {
          currencies = resp.data;
          for (let j in currencies) {
            if (currencies[j].symbol == "BLU") {
              this[this.cryptoEquivalence[i]] = currencies[j];
            }
          }
        } else {
          console.log("something wrong!");
        }
      }
    },

    async getMaintenanceStatus() {
      try {
        this.maintenanceStatus = await this.$store.dispatch(
          "getMaintenanceStatus"
        );
      } catch (e) {
        throw e;
      }
    },

    startInterval() {
      this.updateBalance = setInterval(this.getBalance, 30000);
    },

    async getBalance() {
      this.$store.dispatch("updateBluAccount");
      try {
        let bluAccount = await this.$store.dispatch(
          "getAccountSelected",
          "BLU"
        );
        this.balance = bluAccount.balance;
      } catch (e) {
        throw e;
      }
    },

    tabSwap(el) {
      this.state = el;
    },

    maintenanceCheck(maintananceStatus) {
      this.maintenanceStatus = maintananceStatus;
    },

    async getAssetsTail() {
      let params = {
        offset: 0,
        limit: 50,
        entryType: "live",
      };

      let resp = await this.$store.dispatch("getAssetsTail", params);
      let asset = resp.data;

      this.orderAssetList(asset);
    },

    orderAssetList(asset) {
      let arrayIndex = asset;
      let arrayOpe = [];

      let otherCrypto = {
        assignedOverallWeight: 0,
        currency: {
          name: "Other cryptos",
          symbol: "OTC",
        },
        quantity: 0,
        pairPriceApplied: "",
      };

      asset.sort(function (a, b) {
        return a.assignedOverallWeight > b.assignedOverallWeight
          ? -1
          : a.assignedOverallWeight < b.assignedOverallWeight
          ? 1
          : 0;
      });

      this.assetList = asset;
      this.$store.commit("setAssetList", this.assetList);
    },

    showModalCurrencies(el) {
      this.type = el;
      this.modalCurrencies = !this.modalCurrencies;
    },

    showModalBlueClub(el) {
      this.type = el;
      this.modalBlueClubInfo = !this.modalBlueClubInfo;
    },

    showModalClainBlueClub(el) {
      this.type = el;
      this.modalClainBlueClubInfo = !this.modalClainBlueClubInfo;
    },
  },
  computed: {
    ...mapGetters(["bluAccount", "usdtValue"]),
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/views/private/Landing2.vue